// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import VueQuillEditor from 'vue-quill-editor'

// import external stylesheets
// import '../node_modules/font-awesome/css/font-awesome.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import '../node_modules/bulma/css/bulma.css'
import '../node_modules/bulma-tooltip/dist/css/bulma-tooltip.min.css'

// main style sheet
import './assets/style.css'

// import vue-quill-editor styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueFire) // activate vuefire plugin
Vue.use(VueQuillEditor) // activate vue-quill-editor
Vue.config.productionTip = false
// Vue.use(pdfmake)

/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js